import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

const steps = [
  'Careers',
  'Watch our immersive video',
  'Chat with our AI Bot',
];

const VIDEO_STEP = 1;
const CHAT_STEP = 2;
const STEP_CLASS = ['careers', 'video', 'chat'];

const WidgetStepper = ({ currentStep, onStepChange, showVideoTab, showChatTab }) => {
  // Steps keep their numbers (the chat is always step 2) so links with ?step= keep working
  const visibleSteps = steps
    .map((label, index) => ({ label, index }))
    .filter((step) => step.index !== VIDEO_STEP || showVideoTab)
    .filter((step) => step.index !== CHAT_STEP || showChatTab);
  return (
    <Box
      className="tsw-tabs"
      sx={{
        display: 'flex',
        overflow: 'hidden',
        minHeight: '48px',
        height: '48px',
        width: '100%',
        // border: '1px solid #0a1760',
        // no coloured lines: just 1px of space between the tabs and under them
        gap: '1px',
        borderBottom: '1px solid transparent',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
      }}
    >
      {visibleSteps.map(({ label, index: stepIndex }) => (
        <Button
          key={label}
          className={`tsw-tab tsw-tab-${STEP_CLASS[stepIndex]}`}
          onClick={() => onStepChange(stepIndex)}
          disableRipple
          fullWidth
          sx={{
            borderRadius: 0,
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            textTransform: 'none',
            fontWeight: currentStep === stepIndex ? 700 : 500,
            color: '#000',
            backgroundColor: currentStep === stepIndex ? '#f9a748' : '#fff',
            // borderLeft: index !== 0 ? '1px solid #0a1760' : 'none',
            border: 0,
            boxShadow: 'none',
            px: { xs: 1, sm: 2, md: 3 },
            minWidth: 0,
            whiteSpace: 'normal',
            lineHeight: 1.2,
            height: '100%',
            fontSize: { xs: '0.7rem', sm: '0.85rem', md: '1rem' },
            '&:hover': {
              backgroundColor: currentStep === stepIndex ? '#f9a748' : '#f0f0f0',
            },
          }}
        >
          {label}
        </Button>
      ))}
    </Box>

  );
};

WidgetStepper.propTypes = {
  currentStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func.isRequired,
  showVideoTab: PropTypes.bool,
  showChatTab: PropTypes.bool,
};

WidgetStepper.defaultProps = {
  showVideoTab: true,
  showChatTab: true,
};

export default WidgetStepper;
